module.exports = __webpack_public_path__ + "img/icon-receipt.7523770a.svg";